import {
  type CustomFieldUsage,
  type CustomFieldValueConstructorData,
  type CustomFieldConstructorData,
  type CustomFieldValueOption,
} from '../../entities/internal/CustomField'
import {
  type CustomFieldValueApiModel,
  type CustomFieldApiModel,
} from '../api-models/CustomField'
import { type CustomFieldValueOptionApiModel } from '../api-models/CustomFieldValueOptionApiModel'
import { type CustomFieldUsageApiModel } from '../repositories/CustomFieldRepository/types/GetCustomFieldUsageResponse'

export const mapCustomField = (
  customField: CustomFieldApiModel
): CustomFieldConstructorData => ({
  id: customField.id,
  name: customField.name,
  type: customField.field_type,
  choices: customField.field_choices,
  required: customField.is_required,
  active: customField.is_active,
  defaultValue: customField.default_value,
})

export const mapCustomFieldUsage = (
  usage: CustomFieldUsageApiModel
): CustomFieldUsage => ({
  limit: usage.limit,
  counts: usage.counts.map((entry) => ({
    contentType: entry.content_type,
    count: entry.count,
  })),
})

export const mapCustomFieldValue = (
  customFieldValue: CustomFieldValueApiModel
): CustomFieldValueConstructorData => ({
  id: customFieldValue.id,
  value: customFieldValue.value,
  field: mapCustomField(customFieldValue.field),
})

export const mapCustomFieldValueOption = (
  valueOption: CustomFieldValueOptionApiModel
): CustomFieldValueOption => ({
  value: valueOption.value,
  isAvailable: valueOption.is_available,
})
